import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOneToMany = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.9961 9.75L8.17019 9.75L4.87734 5.98867M4.87734 5.98867L1.30327 5.98867M4.87734 5.98867L11.9961 5.98867M4.87734 5.98867L8.17019 2.25003L11.996 2.25003",
		stroke: "currentColor",
		strokeWidth: 1.1,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgOneToMany;
